import { AxiosRequestConfig, AxiosResponse } from 'axios'

import apiClient from '@/core/api/client'

export const roleService = {
	/**
	 * Get all roles
	 */
	getAllRoles(config?: AxiosRequestConfig): Promise<AxiosResponse> {
		return apiClient.get('/roles/all', config)
	},
}

export default roleService
